export default {
    props: {
        options: {
            default: () => [],
            type: Array,
            required: false
        },
        mode: {
            default: () => "options",
            type: String,
            required: false,
            validator: (value) => ["options", "search"].includes(value)
        },
        label: {
            default: () => "",
            type: String,
            required: false
        },
        labelBold: {
            default: () => false,
            type: Boolean,
            required: false
        },
        placeholder: {
            default: () => "Selecciona una opción",
            type: String,
            required: false
        },
        error: {
            default: () => "",
            type: String,
            required: false
        },
        disabled: {
            default: () => false,
            type: Boolean,
            required: false
        }
    },
    data: () => ({
        open: false,
        query: "",
        highlightedIndex: -1,
        dropdownStyle: {},
        popupItem: null
    }),
    computed: {
        filteredOptions() {
            if (this.mode !== "search" || !this.query) return this.options;
            const query = this.query.toLowerCase();
            return this.options.filter((option) =>
                `${option.label}`.toLowerCase().includes(query)
            );
        }
    },
    watch: {
        open(value) {
            if (value) {
                this.$nextTick(() => this.attachDropdownToBody());
                window.addEventListener(
                    "scroll",
                    this.updateDropdownPosition,
                    true
                );
                window.addEventListener("resize", this.updateDropdownPosition);
            } else {
                window.removeEventListener(
                    "scroll",
                    this.updateDropdownPosition,
                    true
                );
                window.removeEventListener(
                    "resize",
                    this.updateDropdownPosition
                );
            }
        }
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.updateDropdownPosition, true);
        window.removeEventListener("resize", this.updateDropdownPosition);
        if (this.$refs.panel && this.$refs.panel.parentNode) {
            this.$refs.panel.parentNode.removeChild(this.$refs.panel);
        }
    },
    methods: {
        attachDropdownToBody() {
            const panel = this.$refs.panel;
            if (!panel) return;
            if (panel.parentNode !== document.body) {
                document.body.appendChild(panel);
            }
            this.popupItem = panel;
            this.updateDropdownPosition();
            if (this.mode === "search") {
                const input = panel.querySelector("input");
                if (input) input.focus();
            }
        },
        updateDropdownPosition() {
            const trigger = this.$refs.trigger;
            const panel = this.$refs.panel;
            if (!trigger) return;
            const rect = trigger.getBoundingClientRect();
            const panelHeight = panel ? panel.offsetHeight : 0;
            const spaceBelow = window.innerHeight - rect.bottom;
            const spaceAbove = rect.top;
            const shouldOpenUpward =
                spaceBelow < panelHeight && spaceAbove > spaceBelow;

            this.dropdownStyle = {
                position: "fixed",
                left: `${rect.left}px`,
                width: `${rect.width}px`,
                ...(shouldOpenUpward
                    ? { bottom: `${window.innerHeight - rect.top + 4}px` }
                    : { top: `${rect.bottom + 4}px` })
            };
        },
        toggleOpen() {
            if (this.disabled) return;
            this.open = !this.open;
            this.highlightedIndex = -1;
        },
        closeDropdown() {
            this.open = false;
            this.highlightedIndex = -1;
            this.query = "";
            this.popupItem = null;
        },
        onArrowDown() {
            if (!this.open) {
                this.open = true;
                return;
            }
            this.highlightedIndex = Math.min(
                this.highlightedIndex + 1,
                this.filteredOptions.length - 1
            );
        },
        onArrowUp() {
            if (this.highlightedIndex > 0) {
                this.highlightedIndex = this.highlightedIndex - 1;
            }
        },
        onEscape() {
            this.closeDropdown();
        },
        onEnter() {
            if (this.highlightedIndex === -1) return;
            const option = this.filteredOptions[this.highlightedIndex];
            if (option) this.selectOption(option);
        }
    }
};
